import { CloseOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "../styles/components/KeyboardShortcutsButton.css";

interface KeyboardShortcutsButtonState {
  isPopoverOpen: boolean;
  keysPressed: Set<string>;
}

class KeyboardShortcutsButton extends Component<
  RouteComponentProps,
  KeyboardShortcutsButtonState
> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      isPopoverOpen: false,
      keysPressed: new Set(),
    };
  }

  componentDidMount(): void {
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount(): void {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (!event.key) {
      return;
    }

    const { keysPressed } = this.state;

    keysPressed.add(event.key.toUpperCase());
    this.setState({ keysPressed });

    if (event.ctrlKey && event.shiftKey) {
      if (keysPressed.has("V")) {
        event.preventDefault();
        this.props.history.push("/redemption-requests");
      } else if (keysPressed.has("Z")) {
        event.preventDefault();
        this.props.history.push("/transfer-requests");
      } else if (keysPressed.has("O")) {
        event.preventDefault();
        this.props.history.push("/online-transactions");
      } else if (keysPressed.has("C")) {
        event.preventDefault();
        this.props.history.push("/customers");
      } else if (keysPressed.has("P")) {
        event.preventDefault();
        this.props.history.push("/companies");
      } else if (keysPressed.has("I")) {
        event.preventDefault();
        this.props.history.push("/interactions");
      } else if (keysPressed.has("X")) {
        event.preventDefault();
        this.props.history.push("/subCategories");
      }
    }
  };

  handleKeyUp = (event: KeyboardEvent): void => {
    if (!event.key) {
      return;
    }

    const { keysPressed } = this.state;

    keysPressed.delete(event.key.toUpperCase());
    this.setState({ keysPressed });
  };

  handlePopoverVisibleChange = (visible: boolean): void => {
    this.setState({ isPopoverOpen: visible });
  };

  render(): React.ReactNode {
    const { isPopoverOpen } = this.state;

    return (
      <Popover
        content={
          <div className="keyboard-shortcuts-content">
            <div className="shortcuts-title">Keyboard shortcuts</div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Redemption requests</span>
              <kbd className="shortcut-key">Ctrl + Shift + V</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Transfer requests</span>
              <kbd className="shortcut-key">Ctrl + Shift + Z</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Online Transactions</span>
              <kbd className="shortcut-key">Ctrl + Shift + O</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Customers</span>
              <kbd className="shortcut-key">Ctrl + Shift + C</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Companies</span>
              <kbd className="shortcut-key">Ctrl + Shift + P</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Interactions</span>
              <kbd className="shortcut-key">Ctrl + Shift + I</kbd>
            </div>
            <div className="shortcuts-divider"></div>
            <div className="shortcut-item">
              <span>Sub Categories</span>
              <kbd className="shortcut-key">Ctrl + Shift + X</kbd>
            </div>
          </div>
        }
        trigger="click"
        placement="topRight"
        visible={isPopoverOpen}
        onVisibleChange={this.handlePopoverVisibleChange}
      >
        <Button
          className={`keyboard-shortcuts-button ${isPopoverOpen ? "open" : ""}`}
          icon={
            isPopoverOpen ? (
              <CloseOutlined className="close-icon" />
            ) : (
              <svg
                viewBox="0 0 24 24"
                width="1.8em"
                height="1.8em"
                fill="currentColor"
                className="keyboard-icon"
              >
                <path d="M20,5H4C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5M20,17H4V7H20V17M5,8H7V10H5V8M8,8H10V10H8V8M11,8H13V10H11V8M14,8H16V10H14V8M17,8H19V10H17V8M5,11H7V13H5V11M8,11H10V13H8V11M11,11H13V13H11V11M14,11H16V13H14V11M17,11H19V13H17V11M8,14H16V16H8V14Z" />
              </svg>
            )
          }
        />
      </Popover>
    );
  }
}

export default withRouter(KeyboardShortcutsButton);
